import {
  DefaultLocale,
  SupportedCountry,
  SupportedLanguage,
  SupportedLocaleCode,
  SupportedRegion,
} from '../enums'
import { getRegionFromCountry } from './locale-utils'
import {
  getCountryFromLocaleCode,
  getLanguageFromLocaleCode,
} from './localeCode'

export interface Locale {
  code: SupportedLocaleCode
  country: SupportedCountry
  language: SupportedLanguage
  region: SupportedRegion
}

export const getLocaleFromCode = (code: SupportedLocaleCode) => {
  const country = getCountryFromLocaleCode(code)
  return {
    code,
    country,
    language: getLanguageFromLocaleCode(code),
    region: getRegionFromCountry(country),
  }
}

export const getLocaleFromCountryAndLanguage = (
  country: SupportedCountry,
  language: SupportedLanguage,
) => ({
  code: `${language}-${country}` as SupportedLocaleCode,
  country,
  language,
  region: getRegionFromCountry(country),
})

export const getDefaultLocale = () => getLocaleFromCode(DefaultLocale)
